import theme from '../../../../../../styles/theme'
import styled from '@emotion/styled'
import { keyframes, css } from '@emotion/react'

// Props interfaces
interface LeftChildProps {
  disabled?: boolean
}

interface GridProps {
  gap?: string
}

// Vertical stack container
export const VStack = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`

export const TopContainer = styled.div`
  display: flex;
  gap: 50px;
  width: 100%;

  @container VStackBroad (max-width: 800px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }

  min-height: 180px;
`

export const LeftChildOfTopContainer = styled.div<LeftChildProps>`
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};
  pointer-events: ${(props) => (props.disabled ? 'none' : 'auto')};
  transition: opacity 0.3s ease;
`

export const RightChildOfTopContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
`

export const DescriptionContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
  width: 100%;
  flex-wrap: wrap;
  margin-top: 2rem;
`

// Horizontal stack container
export const HStack = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
  flex-direction: row;
`

// Horizontal stack container for the bottom selectors
export const SelectorHStack = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
  margin-top: 2rem;
`

// Horizontal stack container
export const VStackBroad = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0rem;
  container: VStackBroad / inline-size;
`

// Horizontal radio and text
export const HStackRadioComplex = styled.div`
  display: flex;
  gap: 0.5rem;
  flex-direction: row;
  //align-items: center;
  padding-top: 0.5rem;
`

// Grid component
export const MarketCientGrid = styled.div<GridProps>`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1.4rem 0.4rem 1.5rem 0.9rem;
  grid-gap: ${(props) => props.gap || '1rem'};
  width: 100%;
`

export const RequiredLabelStar = styled.span`
  color: ${theme.colors.error};
`

export const InformationText = styled.p`
  font-weight: 500;
`

const clientFieldBorderPulse = keyframes`
  0%, 100% {
    border-color: ${theme.colors.brand};
  }
  50% {
    border-color: ${theme.colors.primaryHighlight};
  }
`

export const ClientPickerHighlight = styled.div<{ $active?: boolean }>`
  position: relative;
  width: 20rem;
  margin: 0;
  padding: 0;
  background: transparent;

  ${(props) =>
    props.$active &&
    css`
      /* StandardSearchField InputWrapper carries the field border */
      & [data-testid='clients-search'] > div:first-of-type {
        border-color: ${theme.colors.brand};
        animation: ${clientFieldBorderPulse} 1.4s ease-in-out infinite;
      }
    `}
`
